import { api } from "aldoo-ra/API"
import { getValue } from "aldoo-ra/Value"

const featureLockAPI = api("feature-lock")

function userId() {
  return getValue("user-credentials")?._id
}

export const FeatureLockAPI = {
  async hasFeature(featureId) {
    const user = userId()
    if (!user) return null
    const res = await featureLockAPI({ check_features: { user, features: [featureId] } })
    return res?.features?.[featureId] === true
  },

  async hasFeatures(featureIds) {
    const user = userId()
    if (!user) return null
    const ids = Array.isArray(featureIds) ? featureIds : [featureIds]
    const res = await featureLockAPI({ check_features: { user, features: ids } })
    return res?.features ?? null
  },

  async getFeatureParam(featureId, param) {
    const user = userId()
    if (!user) return null
    const res = await featureLockAPI({ get_feature_param: { user, feature: featureId, param } })
    return res?.value ?? null
  },
}
